/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bold_Same_Baboon_SewInputs */

const fr_bold_same_baboon_sew = /** @type {(inputs: Bold_Same_Baboon_SewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un email a été envoyé pour changer ton mot de passe`)
};

/**

* @param {Bold_Same_Baboon_SewInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const bold_same_baboon_sew = /** @type {((inputs?: Bold_Same_Baboon_SewInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bold_Same_Baboon_SewInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_bold_same_baboon_sew(inputs)
});